import { defineComponent, ref } from "vue";
import SwitchInput from "../switch-input";
import type { RichSwitchInputProps } from "./types";

const RichSwitchInput = defineComponent({
  setup(props: RichSwitchInputProps) {
    // Create a reactive reference for the switch state
    const switchValue = ref(props.dataRef?.value || false);

    // Handler for switch toggle
    const handleToggle = () => {
      switchValue.value = !switchValue.value;
      const fieldRef = props.fieldRef;
      const dataRef = props.dataRef;

      if (fieldRef) {
        if (props.reportChange) {
          props.reportChange(fieldRef, switchValue.value)
        }
      }
      if (dataRef) {
        dataRef.setValue(switchValue.value)
      }
    };

    return () => {
      return (
        <div class="border border-gray-300 px-4 py-3 flex flex-col gap-2">
          <div class="flex flex-row items-center gap-2 leading-none text-sm font-semibold">
            {props.title}
            <SwitchInput
              locked={props.locked}
              disabled={props.locked}
              value={switchValue.value}
              onToggle={handleToggle}
            />
          </div>
          <div class="text-sm font-normal text-gray-500">{props.subtitle}</div>
        </div>
      );
    };
  }
});

RichSwitchInput.props = ['title', 'subtitle', 'dataRef', 'locked'];

export default RichSwitchInput;